/**
 * US-049 — GENERATED resource vocabulary (reclassification §3.3, 139 keys).
 * Source of truth: backend/scripts/us049-derivation.json.
 * DO NOT EDIT BY HAND — regenerate with: npx tsx backend/scripts/gen-catalog.ts
 *
 * NOTE: the catalog is NOT a pure RESOURCES × {read,write} cross-product (AC2's
 * idealized wording): 4 resources are read-only — ["audit-log","platform-ops","resident-transfer","training-certification"] —
 * and `user-role` is action-only. RESOURCE_SCOPED_KEYS is the authoritative 139.
 */
export const RESOURCES = ["adl-record","analytics","appointment","appointment-form-rule","appointment-type-definition","audit","audit-grant","audit-log","audit-request","auditor-group","auditor-invitation","automation","bed-check-config","bed-check-round","billing-pack","calendar-event","care-note","care-plan","case","case-template","emergency-contact","employee","external-provider","facility","form-requirement","form-submission","form-template","group-home","holiday","incident","invitation","legal-document","medication","notification","permission","pharmacy-partner","platform-ops","request","resident","resident-absence","resident-directory","resident-document","resident-transfer","role","rule-bundle","rule-bundle-application","shift","subscription","training-assignment","training-certification","training-completion","training-material","user","user-role","vital-sign","webhook"] as const;
export type Resource = (typeof RESOURCES)[number];

export type Verb = "read" | "write";

export const ACTION_KEYS = ["adl-record:delete","appointment:delete","appointment:force-complete","audit-grant:revoke","audit-grant:revoke-all","audit-request:approve","audit-request:deny","auditor-invitation:approve","auditor-invitation:deny","automation:manage","care-note:delete","care-plan:delete","care-plan:document","case:close","external-provider:manage","external-provider:verify-npi","form-requirement:waive","form-template:duplicate","form-template:publish","incident:delete","incident:report","legal-document:publish","medication:administer","request:review","resident-document:read-legal","resident-transfer:accept","resident:archive","resident:deceased","resident:ssn-read","resident:transfer","rule-bundle:adopt","rule-bundle:import","rule-bundle:new-version","rule-bundle:publish","shift:manage","user-role:assign","vital-sign:manage"] as const;
export type ActionKey = (typeof ACTION_KEYS)[number];

const ACTION_KEY_SET: ReadonlySet<string> = new Set(ACTION_KEYS);

/**
 * True if `key` is one of the elevated action gates (e.g. medication:administer),
 * not a plain read/write. Single source of truth is ACTION_KEYS — derived, never
 * duplicated as catalog metadata. Use this to distinguish elevated actions in UI,
 * tooling, and CI without re-parsing the verb suffix. Param is `string` so a
 * `PermissionKey` narrows to `ActionKey` on a true result.
 */
export function isActionKey(key: string): key is ActionKey {
  return ACTION_KEY_SET.has(key);
}

/** Typed key builder — a typo'd resource/verb is a compile error (AC9). */
export function keyFor<R extends Resource, V extends Verb>(
  r: R,
  v: V,
): `${R}:${V}` {
  return `${r}:${v}`;
}

/** The ${newKeys.length} resource-scoped keys (read/write + elevated action gates). */
export const RESOURCE_SCOPED_KEYS = [
  "adl-record:delete",
  "adl-record:read",
  "adl-record:write",
  "analytics:read",
  "analytics:write",
  "appointment-form-rule:read",
  "appointment-form-rule:write",
  "appointment-type-definition:read",
  "appointment-type-definition:write",
  "appointment:delete",
  "appointment:force-complete",
  "appointment:read",
  "appointment:write",
  "audit-grant:read",
  "audit-grant:revoke",
  "audit-grant:revoke-all",
  "audit-grant:write",
  "audit-log:read",
  "audit-request:approve",
  "audit-request:deny",
  "audit-request:read",
  "audit-request:write",
  "audit:read",
  "audit:write",
  "auditor-group:read",
  "auditor-group:write",
  "auditor-invitation:approve",
  "auditor-invitation:deny",
  "auditor-invitation:read",
  "auditor-invitation:write",
  "automation:manage",
  "bed-check-config:read",
  "bed-check-config:write",
  "bed-check-round:read",
  "bed-check-round:write",
  "billing-pack:read",
  "billing-pack:write",
  "calendar-event:read",
  "calendar-event:write",
  "care-note:delete",
  "care-note:read",
  "care-note:write",
  "care-plan:delete",
  "care-plan:document",
  "care-plan:read",
  "care-plan:write",
  "case-template:read",
  "case-template:write",
  "case:close",
  "case:read",
  "case:write",
  "emergency-contact:read",
  "emergency-contact:write",
  "employee:read",
  "employee:write",
  "external-provider:manage",
  "external-provider:read",
  "external-provider:verify-npi",
  "external-provider:write",
  "facility:read",
  "facility:write",
  "form-requirement:read",
  "form-requirement:waive",
  "form-requirement:write",
  "form-submission:read",
  "form-submission:write",
  "form-template:duplicate",
  "form-template:publish",
  "form-template:read",
  "form-template:write",
  "group-home:read",
  "group-home:write",
  "holiday:read",
  "holiday:write",
  "incident:delete",
  "incident:read",
  "incident:report",
  "incident:write",
  "invitation:read",
  "invitation:write",
  "legal-document:publish",
  "legal-document:read",
  "legal-document:write",
  "medication:administer",
  "medication:read",
  "medication:write",
  "notification:read",
  "notification:write",
  "permission:read",
  "permission:write",
  "pharmacy-partner:read",
  "pharmacy-partner:write",
  "platform-ops:read",
  "request:read",
  "request:review",
  "request:write",
  "resident-absence:read",
  "resident-absence:write",
  "resident-directory:read",
  "resident-directory:write",
  "resident-document:read-legal",
  "resident-transfer:accept",
  "resident-transfer:read",
  "resident:archive",
  "resident:deceased",
  "resident:read",
  "resident:ssn-read",
  "resident:transfer",
  "resident:write",
  "role:read",
  "role:write",
  "rule-bundle-application:read",
  "rule-bundle-application:write",
  "rule-bundle:adopt",
  "rule-bundle:import",
  "rule-bundle:new-version",
  "rule-bundle:publish",
  "rule-bundle:read",
  "rule-bundle:write",
  "shift:manage",
  "shift:read",
  "shift:write",
  "subscription:read",
  "subscription:write",
  "training-assignment:read",
  "training-assignment:write",
  "training-certification:read",
  "training-completion:read",
  "training-completion:write",
  "training-material:read",
  "training-material:write",
  "user-role:assign",
  "user:read",
  "user:write",
  "vital-sign:manage",
  "vital-sign:read",
  "vital-sign:write",
  "webhook:read",
  "webhook:write",
] as const;
